module.exports = __webpack_public_path__ + "img/business_04.4f195449.jpg";